function getTitle(vm) {
    try {
        return vm.$t('system.resident_portal') + ' | ' + vm.$tc('system.' + vm.$route.name, 2)
    } catch {
       return 'Loading...'
    }
}

export default {
    created() {
        const title = getTitle(this)
        if (title) {
            document.title = title
        }
    }
}
